import { render, staticRenderFns } from "./loses-add-edit.vue?vue&type=template&id=e2b10186&scoped=true&"
import script from "./loses-add-edit.vue?vue&type=script&lang=js&"
export * from "./loses-add-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b10186",
  null
  
)

export default component.exports